import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../../utils/translation";
const DemoManagement = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">{t("admin_demo.title")}</h4>
              <div className="d-flex flex-column gap-2 mt-4 align-items-start">
                <Link
                  to="/demo-management/assign"
                  className="btn btn-info"
                  style={{ backgroundColor: "#5bc0de", borderColor: "#5bc0de", color: "#ffffff" }}
                >
                  {t("admin_demo.buttons.assign")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DemoManagement;
